import { BookmarksHeatmapChartGrouping } from 'components/framework/Enums';
import {
  type BookmarksHeatmapChartDataRow,
  type BookmarksHeatmapChartGrouping_value,
} from 'components/framework/models/generated/types';
import { get } from 'lodash';

export type GroupByConfig = {
  type: BookmarksHeatmapChartGrouping_value;
  // Value in the group by UI drop down
  label: string;
  // Controls if the option should only display when viewing a specific record type
  mode?: 'FEATURE' | 'REQUIREMENT' | 'ANY'; // Use ANY if it should ONLY apply to the Any option
  // Optionally provide a custom display function for rendering the value, defaults to "groupByValue"
  displayValue?: (data?: BookmarksHeatmapChartDataRow) => string;
};

export const GROUP_BY_CONFIG: Record<
  BookmarksHeatmapChartGrouping_value,
  GroupByConfig
> = {
  [BookmarksHeatmapChartGrouping.ASSIGNED_TO.value]: {
    label: 'Assigned to',
    type: BookmarksHeatmapChartGrouping.ASSIGNED_TO.value,
    displayValue(data) {
      return get(data, 'metadata.name', 'Unassigned');
    },
  },
  [BookmarksHeatmapChartGrouping.TYPE.value]: {
    label: 'Type',
    type: BookmarksHeatmapChartGrouping.TYPE.value,
    mode: 'FEATURE',
  },
  [BookmarksHeatmapChartGrouping.ITERATION.value]: {
    label: 'Iteration',
    type: BookmarksHeatmapChartGrouping.ITERATION.value,
  },
  [BookmarksHeatmapChartGrouping.INITIAL_ESTIMATE.value]: {
    label: 'Initial estimate',
    type: BookmarksHeatmapChartGrouping.INITIAL_ESTIMATE.value,
    displayValue(data) {
      return !data || !data.groupByValue || data.groupByValue === 'null'
        ? 'No Estimate'
        : data.groupByValue;
    },
  },
  [BookmarksHeatmapChartGrouping.DETAILED_ESTIMATE.value]: {
    label: 'Detailed estimate',
    type: BookmarksHeatmapChartGrouping.DETAILED_ESTIMATE.value,
    displayValue(data) {
      return !data || !data.groupByValue || data.groupByValue === 'null'
        ? 'No Estimate'
        : data.groupByValue;
    },
  },
  [BookmarksHeatmapChartGrouping.RELEASE.value]: {
    label: 'Release',
    type: BookmarksHeatmapChartGrouping.RELEASE.value,
    mode: 'FEATURE',
  },
  [BookmarksHeatmapChartGrouping.FEATURE.value]: {
    label: 'Feature name',
    type: BookmarksHeatmapChartGrouping.FEATURE.value,
    mode: 'REQUIREMENT',
  },
  [BookmarksHeatmapChartGrouping.RECORD_TYPE.value]: {
    label: 'Record type',
    type: BookmarksHeatmapChartGrouping.RECORD_TYPE.value,
    mode: 'ANY',
  },
  [BookmarksHeatmapChartGrouping.EPIC.value]: {
    label: 'Epic',
    type: BookmarksHeatmapChartGrouping.EPIC.value,
    mode: 'FEATURE',
  },
  [BookmarksHeatmapChartGrouping.INITIATIVE.value]: {
    label: 'Initiative',
    type: BookmarksHeatmapChartGrouping.INITIATIVE.value,
    mode: 'FEATURE',
  },
};
